const toDate = (number) => {
    var date = new Date(number);
    return new Date(number + (date.getTimezoneOffset() * 60000));
};


const toNumber = (date) => {

        if (date instanceof Date) {
            var t = 1;
            return date?.getTime() - (date?.getTimezoneOffset() * 60000);

        } else {
            var castedDate = date ? new Date(date) : null;
            return castedDate?.getTime() - (castedDate?.getTimezoneOffset() * 60000);
        }
    

}

export { toDate, toNumber }